<template>
  <Head title="Projects" />

  <BreezeAuthenticatedLayout>
    <main class="container">
      <div class="py-12">
        <div class="c-header">
          <a href="" onclick="javascript:history.back(); return false;" class="c-header__back">
            <img src="/images/icons/icon-chevron-left.svg" alt="back">
          </a>
          <h2 class="c-header--h2">課題を追加 / {{ gym.title }}</h2>
        </div>

        <div v-if="$page.props.flash.message" class="message">
          {{ $page.props.flash.message }}
        </div>

        <div class="mt-24">
          <form @submit.prevent="storeProject">
            <div class="mt-24">
              <label for="title">課題名<span class="required">必須</span></label>
              <div class="mt-1">
                <input v-if="$page.props.flash.message" type="text" id="name" name="name" v-model="form.name">
                <input v-else type="text" id="name" name="name" v-model="form.name">

                <div v-if="form.errors.name" class="error">課題名を入力してください</div>
              </div>
            </div>

            <div class="mt-24">
              <label for="title">グレード<span class="required">必須</span></label>
              <div class="mt-1">
                <select v-model="form.grade_id" :error="form.errors.grade" label="grade">
                  <option v-for="grade in grades" :value="grade.id">
                    {{grade.title}}
                  </option>
                </select>
                <div v-if="form.errors.grade_id" class="error">グレードを選択してください</div>

              </div>
            </div>
            <div class="mt-24">
              <label for="title">ウォール<span class="required">必須</span></label>
              <div class="mt-1">
                <select v-model="form.wall_id" :error="form.errors.wall" label="wall_id">
                  <option v-for="wall in walls" :value="wall.id">
                    {{wall.name}}
                  </option>
                </select>
                <div v-if="form.errors.wall_id" class="error">ウォールを選択してください</div>
              </div>
            </div>

            <div class="mt-24">
              <label for="title">カテゴリー<span class="required">必須</span></label>
              <div class="mt-1">
                <select v-model="form.category_id" :error="form.errors.category" label="category_id">
                  <option v-for="category in categories" :value="category.id">
                    {{category.name}}
                  </option>
                </select>
                <div v-if="form.errors.category_id" class="error">カテゴリーを選択してください</div>
              </div>
            </div>

            <div class="mt-24">
              <label for="title">期間</label>
              <div class="mt-1">

                <input type="date" v-model="form.startdate" onkeydown="return false" name="startdate">
                <p>〜</p>
                <input type="date" v-model="form.enddate" onkeydown="return false" name="enddate">

              </div>
            </div>
            <div class="mt-24">
              <label for="memo">メモ</label>
              <div class="mt-1">
                <textarea v-model="form.memo" name="memo" placeholder="備考欄"></textarea>
              </div>
            </div>
            <div class="mt-24">
              <label for="title">課題画像</label>
              <div class="mt-1">
                <input type="file" id="image" wire:model="newImage" name="image" 
                @input="form.image = $event.target.files[0]" />
              </div>
            </div>
            <div class="mt-36">
              <div class="mt-1">
                <label for="continue_register">
                <input type="checkbox" v-model="form.continue_register" name="continue_register" id="continue_register">
                続けて登録する</label>
              </div>
            </div>
            <div class="mt-36">
              <div class="c-button-wrap">
                <button type="submit" class="c-button">追加する</button>
              </div>
            </div>
          </form>

        </div>

      </div>
      <Side />
    </main>
  </BreezeAuthenticatedLayout>
</template>

<script>
import { ref, watchEffect, onMounted } from 'vue'
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue'
import { Head, Link, useForm, usePage } from '@inertiajs/inertia-vue3';
import Side from '@/Shared/Side'


export default {
  components: {
    BreezeAuthenticatedLayout,
    Head,
    Link,
    useForm,
    watchEffect,
    Side,
  },
  props: {
    gym: Object,
    grades: Object,
    walls: Object,
    categories: Object
  },
  setup(props) {
    const form = useForm({
      name: null,
      gym_id: props.gym.id,
      grade_id: props.grades[0].id,
      wall_id: props.walls[0].id,
      category_id: props.categories[0].id,
      startdate: null,
      enddate: null,
      continue_register: null,
      memo: null,
      image: null,
    });

    const grades = props.grades
    const startdate = ref(null)
    const enddate = ref(null)

    watchEffect(() => {
      if(startdate.value > enddate.value) {
        const tmp = enddate.value
        enddate.value = startdate.value
        startdate.value = tmp
      }

      // 続けて登録する処理
      if(usePage().props.value.flash.message) {
        form.name = null
        form.memo = null
        form.image = null
      }
    })

    return {
      form,
      startdate,
      enddate,
    }
  },
  methods: {
    storeProject() {
      this.form.post('/projects')
    }
  }
}

</script>
